import { mountClassic } from '../render/classic/classic-app.js';
import { freecellClassicSpec } from '../variants/freecell/classic-spec.js';

const root = document.getElementById('classic-stage');
if (!root) throw new Error('missing #classic-stage');
mountClassic(freecellClassicSpec, { root, title: 'FreeCell' });
